import { Whiteboard } from './board.js';
import { containsMath, parseMathSegments, stripMathForPlain } from './math.js';

export { Whiteboard, containsMath, parseMathSegments, stripMathForPlain };

if (typeof window !== 'undefined') {
  window.CmnoteWhiteboard = {
    Whiteboard,
    containsMath,
    parseMathSegments,
    stripMathForPlain,
  };
}
